import Api from "@/services/Api";
import SystemConst from "@/config/const";

export default {
  getTickets(query: any) {
    let url = `/users/ticket_favorites?page=${query.page}&per_page=${query.per_page}`;
    if (
      query.ticket_type &&
      query.ticket_type !== SystemConst.TICKET_TYPE_ALL
    ) {
      url += `&ticket_type=${query.ticket_type}`;
    }
    return Api().get(url);
  },
  getTicket(ticket_id: number | string) {
    return Api().get(`/users/ticket_favorites/${ticket_id}`);
  },
  deleteTicket(ticket_id: number | string) {
    return Api().delete(`/users/ticket_favorites/${ticket_id}`);
  },
  createTicket(params: object) {
    return Api().post(`/users/ticket_favorites`, params);
  }
};
